import { cn } from "@/lib/utils";
import { contentLabelsSelector } from "@/redux/loadedContent/loadedContentSlice";
import { HeatmapCell } from "@/redux/players/playersSlice";
import { useState } from "react";
import { useSelector } from "react-redux";

import { DynamicHeatmap } from "./DynamicHeatmap";

type Props = {
  heatmapValues: HeatmapCell[];
  focus: string;
  active: boolean;
  onClick: (focus: string) => void;
};

export const PlayerFocus = ({
  focus,
  heatmapValues,
  active,
  onClick,
}: Props) => {
  const [hover, setHover] = useState(false);
  const { focuses } = useSelector(contentLabelsSelector);

  return (
    <button
      onClick={() => onClick(focus)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={cn(
        "flex flex-col border-2 items-center px-1.5 pb-0.5 pt-1.5 justify-center  text-xs text-center rounded shadow-hard bg-white/5 desktop:hover:bg-white/20 gap-y-1",
        active ? "border-primary-dark-blue " : "border-transparent",
      )}
    >
      <DynamicHeatmap cells={heatmapValues} className="w-full" />
      <p className={cn(hover ? "text-white" : "text-gray-300")}>
        {focuses[focus]?.name ?? focus}
      </p>
    </button>
  );
};
